<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix">
                <el-form :inline="true">
                    <el-form-item><span style="font-weight: bolder">转冷配置</span></el-form-item>
                    <el-form-item label="币种">
                        <el-input v-model="coinType"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="query(1)">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="showEdit = true">新增</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary">
                            <span>转冷总开关</span>&nbsp;&nbsp;&nbsp;
                            <el-switch v-model="headSwitch" active-color="#13ce66" inactive-color="#ff4949"
                                       @change="buildHeadSwitch()"></el-switch>
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="configList">
                <el-table-column prop="coinType" label="币种"/>
                <el-table-column prop="depositReserve" label="充值预留值"/>
                <el-table-column prop="withdrawReserve" label="提现预留值"/>
                <el-table-column prop="transferWithdrawThreshold" label="转提现阈值"/>
                <el-table-column prop="transferColdThreshold" label="转冷阈值"/>
                <el-table-column label="转冷模型">
                    <template slot-scope="scope">
                        {{parseDesc(scope.row.type,coldTypes)}}
                    </template>
                </el-table-column>
                <el-table-column prop="coldSwitch" label="转冷开关">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.coldSwitch" active-color="#13ce66" inactive-color="#ff4949"
                                   @change="changeSwitch(scope.row)"/>
                    </template>
                </el-table-column>
                <el-table-column prop="runningSwitch" label="正在转冷开关">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.runningSwitch" active-color="#13ce66"
                                   inactive-color="#ff4949" @change="changeRunningSwitch(scope.row)"/>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="text" @click="deleteConfig(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination background layout="prev, pager, next" :total="configTotal" :page-size="15"
                           :current-page="page" @current-change="query"/>
        </el-card>

        <el-dialog :visible.sync="showEdit" @close="closeEdit()" width="30%" center>
            <template slot="title"><span style="font-weight: bolder">转冷配置</span></template>
            <el-form label-width="150px" :model="editInfo" ref="editForm">
                <el-form-item label="币种" :rules="[{required: true, message: '请输入币种'}]" prop="coinType">
                    <el-input v-model="editInfo.coinType"/>
                </el-form-item>
                <el-form-item label="转冷开关">
                    <el-switch v-model="editInfo.coldSwitch" active-color="#13ce66" inactive-color="#ff4949"/>
                </el-form-item>
                <el-form-item label="转冷模型" :rules="[{required: true, message: '请选择转冷模型'}]" prop="type">
                    <el-select v-model="editInfo.type">
                        <el-option v-for="item in coldTypes" :label="item.desc" :key="item.code" :value="item.code"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="充值预留值" :rules="[{required: true, message: '请输入充值预留值'}]" prop="depositReserve">
                    <el-input v-model="editInfo.depositReserve"/>
                </el-form-item>
                <el-form-item label="提现预留值" :rules="[{required: true, message: '请输入提现预留值'}]" prop="withdrawReserve">
                    <el-input v-model="editInfo.withdrawReserve"/>
                </el-form-item>
                <el-form-item label="转提现阈值" :rules="[{required: true, message: '请输入转提现阈值'}]"
                              prop="transferWithdrawThreshold">
                    <el-input v-model="editInfo.transferWithdrawThreshold"/>
                </el-form-item>
                <el-form-item label="转冷阈值" :rules="[{required: true, message: '请输入转冷阈值'}]" prop="transferColdThreshold">
                    <el-input v-model="editInfo.transferColdThreshold"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeEdit()">取消</el-button>
                    <el-button type="primary" @click="editSubmit()">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import api from './api';

    export default {
        name: "transferColdWallet",
        data() {
            return {
                coinType: '',
                page: 1,
                configList: [],
                configTotal: 0,
                showEdit: false,
                editInfo: {
                    coinType: '',
                    coldSwitch: false,
                    type: '',
                    depositReserve: 0,
                    withdrawReserve: 0,
                    transferWithdrawThreshold: 0,
                    transferColdThreshold: 0,
                },
                headSwitch: false,
                coinTypeEosErc20: '',
                pageE: 1,
                childTotal: 0,
                childSwitchInfo: [],
                coldTypes: [
                    {code: 'EXIST_COLD_SINGLE_DEPOSIT_SINGLE_WITHDRAW', desc: '存在冷钱包，单一充值地址'},
                    {code: 'EXIST_COLD_MORE_DEPOSIT_SINGLE_WITHDRAW', desc: '存在冷钱包，多个充值地址'},
                    {code: 'NOT_EXIST_COLD_SINGLE_DEPOSIT_SINGLE_WITHDRAW', desc: '无冷钱包，单一充值地址'},
                    {code: 'NOT_EXIST_COLD_MORE_DEPOSIT_SINGLE_WITHDRAW', desc: '无冷钱包，多个充值地址'},
                    {code: 'NOT_EXIST_COLD_MORE_DEPOSIT_MULTI_WITHDRAW', desc: '无冷钱包,多个充值地址多个提现地址'},
                    {code: 'NOT_EXIST_COLD_TRXLIKE_MORE_DEPOSIT_SINGLE_WITHDRAW', desc: 'TRXLIKE无冷钱包，多个充值地址'},
                    {code: 'EXIST_COLD_BITLIKE_DEPOSIT_ACCOUNT_WITHDRAW', desc: 'BITLIKE存在冷钱包'},
                    {code: 'NOT_EXIST_COLD_BITLIKE_DEPOSIT_ACCOUNT_WITHDRAW', desc: 'BITLIKE不存在冷钱包'},
                    {code: 'EXIST_COLD_USDTLIKE_MORE_DEPOSIT_SINGLE_WITHGRAW', desc: 'USDTLIKE存在冷钱包'},
                ]
            }
        },
        created() {
            this.query(1);
            api.getHeadColdSwitch().then(response => {
                this.headSwitch = response.data;
            })
        },
        methods: {
            query(val) {
                this.page = val;
                api.queryConfigList({coinType: this.coinType, page: this.page}).then(response => {
                    this.configList = response.data.list;
                    this.configTotal = response.data.totalCount;
                })
            },
            edit(info) {
                this.editInfo = info;
                this.showEdit = true;
            },
            deleteConfig(row) {
                this.$confirm('确认删除该配置吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteConfig({coinType: row.coinType}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.query(1);
                    });
                }).catch(() => {
                });
            },
            closeEdit() {
                this.editInfo = {
                    coinType: '',
                    coldSwitch: false,
                    depositReserve: 0,
                    withdrawReserve: 0,
                    transferWithdrawThreshold: 0,
                    transferColdThreshold: 0,
                };
                this.$refs['editForm'].resetFields();
                this.showEdit = false;
            },
            changeSwitch(info) {
                api.configToColdWallet(info);
            },
            editSubmit() {
                this.$refs['editForm'].validate(valid => {
                    if (valid) {
                        api.configToColdWallet(this.editInfo).then(() => {
                            this.$message.success('操作成功');
                            this.query(1);
                            this.closeEdit();
                        })
                    }
                })
            },
            buildHeadSwitch() {
                api.saveHeadColdSwitch({coldWalletSwitch: this.headSwitch});
            },
            parseDesc(code, list) {
                for (let i in list) {
                    if (code === list[i].code) {
                        return list[i].desc;
                    }
                }
            },
            changeRunningSwitch(row) {
                this.setCodeRunningSwitch(row.coinType, row.runningSwitch);
            },
            setCodeRunningSwitch(coinType, value) {
                api.setCodeRunningSwitch({coinType: coinType, status: value == true ? "true" : "false"}).then(() => {
                    this.query(1);
                    api.getHeadColdSwitch().then(response => {
                        this.headSwitch = response.data;
                    })
                })
            }
        }
    }
</script>

<style scoped>

</style>
